"use client";

import React from 'react';

export type ToggleContextType = {
  checked: boolean;
  focused: boolean;
  disabled: boolean;
  hovering: boolean;
  tapped: boolean;
};

// @ts-expect-error FIXME(strictNullChecks)
export const ToggleContext = React.createContext<ToggleContextType>(null);
